import React, { createContext, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Stores/Store";
import { ToastContainer } from "react-toastify";
import { StrictMode } from "react";
//hello
export const Context = createContext({ loggedInUser: {} });

const AppWrapper = () => {
  const [loggedInUser, setLoggedInUser] = useState({});
  // const [contextBlogs, setContextBlogs] = useState([]);

  return (
    <Context.Provider value={{ loggedInUser, setLoggedInUser }}>
      <Provider store={store}>
        <ToastContainer />

        <App />
      </Provider>
    </Context.Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <AppWrapper />
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
